export const DRAWER_ASSIGNMENT_WIDTH_DESKTOP = 500;
